// Languages offered for keyword-variation generation. The backend keyword-
// variations endpoint accepts a language name (or ISO code) and biases the
// generated spellings/forms/transliterations toward it.

// Shown as quick-pick chips on the keyword card.
export const DEFAULT_VARIATION_LANGUAGES = [
  'Georgian',
  'English',
  'Russian',
  'German',
  'French',
  'Spanish',
] as const

// Full list shown in the "Add Language" modal.
export const ALL_VARIATION_LANGUAGES = [
  'Georgian',
  'English',
  'Russian',
  'German',
  'French',
  'Spanish',
  'Chinese',
  'Arabic',
  'Portuguese',
  'Japanese',
  'Italian',
  'Korean',
  'Turkish',
  'Dutch',
  'Polish',
  'Ukrainian',
  'Greek',
  'Swedish',
  'Hebrew',
  'Czech',
] as const
